import * as Yup from 'yup'

export const tipoUnidadeSchema = Yup.object().shape({
  nome: Yup.string().trim().required('Nome é obrigatório'),
})
